import { SupportedTLD } from '@eversports/react-app-base/tld-configs'

import NotificationsIcon from '../../../../static/notifications.svg'
import RecommendationsIcon from '../../../../static/recommendations.svg'
import { ManagerLinksMapping } from '../../../App.constants'
import { From } from '../../../App.types'
import ForBusinessesIcon from '../../../assets/icons/for-businesses.svg'
import ForCorporatesIcon from '../../../assets/icons/for-corporates.svg'
import FriendsIcon from '../../../assets/icons/friends.svg'
import HomeIcon from '../../../assets/icons/home.svg'
import MyBookingsIcon from '../../../assets/icons/my-bookings.svg'
import MyFavoritesIcon from '../../../assets/icons/my-favorites.svg'
import MyPassesIcon from '../../../assets/icons/my-passes.svg'
import MyPaymentMethodsIcon from '../../../assets/icons/my-payment-methods.svg'
import MyPersonalInformationIcon from '../../../assets/icons/my-personal-information.svg'
import MyPrivacySettingsIcon from '../../../assets/icons/my-privacy-settings.svg'
import MyProfileIcon from '../../../assets/icons/my-profile.svg'
import MyVideosIcon from '../../../assets/icons/my-videos.svg'
import SignoutIcon from '../../../assets/icons/signout.svg'
import { Localized } from '../../../localization/react'
import NumberOfPendingFriendRequests from '../../NumberOfPendingFriendRequests'
import UnreadNotificationCount from '../../UnreadNotificationsCount'

import { UserProfileRoutes } from './UserMenu.constants'
import { UserItem } from './UserMenu.types'

interface NonLoggedInUserMenuItemsArgs {
  tld: SupportedTLD
}

export const LoggedInUserMenuItems: Array<UserItem> = [
  {
    icon: MyBookingsIcon,
    label: <Localized id="user-menu-item-my-bookings" />,
    to: UserProfileRoutes.MY_BOOKINGS,
    isExternal: true,
  },
  {
    icon: MyVideosIcon,
    label: <Localized id="user-menu-item-my-videos" />,
    to: UserProfileRoutes.MY_VIDEOS,
    isExternal: true,
  },
  {
    icon: MyPassesIcon,
    label: <Localized id="user-menu-item-my-passes-and-memberships" />,
    to: UserProfileRoutes.MY_PASSES,
    isExternal: true,
  },
  {
    icon: MyFavoritesIcon,
    label: <Localized id="user-menu-item-my-favorites" />,
    to: UserProfileRoutes.MY_FAVORITES,
    isExternal: true,
  },
  {
    icon: MyPersonalInformationIcon,
    label: <Localized id="user-menu-item-my-personal-information" />,
    to: UserProfileRoutes.MY_INFO,
    isExternal: true,
  },
  {
    icon: MyPaymentMethodsIcon,
    label: <Localized id="user-menu-item-my-payment-methods" />,
    to: UserProfileRoutes.MY_PAYMENT_METHODS,
    isExternal: true,
  },
  {
    icon: MyPrivacySettingsIcon,
    label: <Localized id="user-menu-item-my-privacy-settings" />,
    to: UserProfileRoutes.MY_PRIVACY_SETTINGS,
    hasDivider: true,
    isExternal: true,
  },
  {
    icon: SignoutIcon,
    label: <Localized id="user-menu-item-signout" />,
    to: UserProfileRoutes.SIGNOUT,
    isExternal: true,
  },
]

export const NonLoggedInUserMenuItems = ({ tld }: NonLoggedInUserMenuItemsArgs): Array<UserItem> => [
  {
    icon: HomeIcon,
    label: <Localized id="user-menu-item-home" />,
    to: UserProfileRoutes.HOME,
    isExternal: false,
  },
  {
    icon: ForCorporatesIcon,
    label: <Localized id="user-menu-item-for-corporates" />,
    to: ManagerLinksMapping[tld].corporate,
    isExternal: true,
  },
  {
    icon: ForBusinessesIcon,
    label: <Localized id="user-menu-item-for-businesses" />,
    to: ManagerLinksMapping[tld].business,
    isExternal: true,
  },
]

export const PublicUserFeatureMenuItems = ({ userHandle }: { userHandle: string }): Array<UserItem> => [
  {
    icon: MyProfileIcon,
    label: <Localized id="user-menu-item-my-public-profile" />,
    to: `/user/${userHandle}?from=${From.USER_MENU}`,
    isExternal: false,
  },
  {
    icon: FriendsIcon,
    label: <Localized id="user-menu-item-my-friends" />,
    to: `/user/${userHandle}/friends?from=${From.USER_MENU}`,
    isExternal: false,
    notification: <NumberOfPendingFriendRequests />,
  },
]

export const HomeUserItem = {
  to: UserProfileRoutes.HOME,
  icon: HomeIcon,
  label: <Localized id="user-menu-item-home" />,
  hasDivider: true,
  isExternal: false,
}

export const RecommendationsUserItem = {
  to: UserProfileRoutes.RECOMMENDATIONS,
  icon: RecommendationsIcon,
  label: <Localized id="recommendations" />,
  isExternal: false,
}

export const NotificationsUserItem = {
  to: UserProfileRoutes.NOTIFICATIONS,
  icon: NotificationsIcon,
  label: <Localized id="notifications" />,
  isExternal: false,
  notification: <UnreadNotificationCount />,
}
